// Persistent per-browser voter id for belief votes and fact-debate stances.
// Stored in localStorage so it survives tab close / refresh / new tabs (unlike sessionStorage).
// This is NOT used for authentication — it's just enough to enforce one-vote-per-browser
// without forcing users to make an account.

const VOTER_KEY = "vault.voter.id";

export function getVoterId() {
  try {
    let v = localStorage.getItem(VOTER_KEY);
    if (!v) {
      v = (typeof crypto !== "undefined" && crypto.randomUUID)
        ? crypto.randomUUID()
        : `voter-${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;
      localStorage.setItem(VOTER_KEY, v);
    }
    return v;
  } catch {
    // Private mode etc. — fall back to a tab-scoped id so feature still works for the session
    return `anon-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
  }
}
